module.exports = __webpack_public_path__ + "static/media/11_andinvainthedreamer.66a0b668.jpg";